import { BdsGrid, BdsTypo } from 'blip-ds/dist/blip-ds-react/components';
import './MetricsTitle.scss';

type MetricsTitleProps = Readonly<{
    title: string;
}>;

export function MetricsTitle({ title }: MetricsTitleProps) {
    return (
        <BdsGrid alignItems="center" gap="1">
            <BdsTypo lineHeight="plus" variant="fs-16" bold="semi-bold" margin={false} className="metricsTitle">
                {title}
            </BdsTypo>
        </BdsGrid>
    );
}
